import React, { useCallback, useMemo, useState } from 'react';
import IconMap from '../icons/IconMap';
import IconReport from '../icons/IconReport';
import IconList from '../icons/IconList';
import IconHeart from '../icons/IconHeart';
import IconSearch from '../icons/IconSearch';
import IconPrint from '../icons/IconPrint';
import IconArrowDown from '../icons/IconArrowDown';
import SlideToggle from 'react-slide-toggle';
import useUI from '../hooks/useUI';
import useApp from '../hooks/useApp';
import useData from '../hooks/useData';
import { uniq } from 'underscore';

const LeftPanel = () => {
	const { closeAllUI, toggleUI, ExhibitorList, MobileMenu } = useUI();
	const { isCHT, activeFloor, setExhibitorSection, exhibitorSection, setCHT, setENG } = useApp();
	const { basicInfo, exhibitorInfo } = useData();

	const showMap = useCallback(() => {
		closeAllUI();
	}, [closeAllUI]);

	const showExhibitionInfo = useCallback(() => {
		toggleUI('ExhibitionInfo');
	}, [toggleUI]);

	const showExhibitorList = useCallback((section) => {
		if (!ExhibitorList) toggleUI('ExhibitorList');
		if (section) setExhibitorSection(section);
	}, [ExhibitorList, setExhibitorSection, toggleUI]);

	const showMyFavourites = useCallback(() => {
		toggleUI('MyFavourites');
	}, [toggleUI]);

	const showSearch = useCallback(() => {
		toggleUI('SearchPanel');
	}, [toggleUI]);

	const currentUrl = window.location.href;

	const exhibitorSections = useMemo(() => {
		const key = isCHT ? '區域-中文' : '區域-英文';
		const uniqueSections = uniq(exhibitorInfo.map(exhibitor => exhibitor[key]));
		return uniqueSections;
	}, [exhibitorInfo, isCHT]);

	const toggleMenu = useCallback(() => {
		toggleUI('MobileMenu');
	}, [toggleUI]);

	const toggleLanguage = useCallback(() => {
		if (isCHT) setENG();
		else setCHT();
	}, [isCHT, setCHT, setENG]);


	return (
		<div id='LeftPanel'>
			<div className='mobile-menu'>
				<div className='exhibition-name'>
					{isCHT ? basicInfo.nameCHT : basicInfo.nameENG}
				</div>

				<div className='controls'>
					<div className='language-chooser' onClick={toggleLanguage}>{isCHT ? 'En' : '中'}</div>
					<div className='menu-toggler' onClick={toggleMenu}></div>
				</div>
			</div>

			<div className={`mobile-drawer ${MobileMenu ? 'active' : ''}`}>
				<div className='control-item' onClick={showMap}>
					<IconMap />
					<div className='text'>{isCHT ? '展會地圖' : 'Exhibition Map'}</div>
				</div>

				<div className='control-item' onClick={showExhibitionInfo}>
					<IconReport />
					<div className='text'>{isCHT ? '展會簡介' : 'Exhibition Info'}</div>
				</div>

				<SlideToggle collapsed>
					{({ toggle, setCollapsibleElement }) => (
						<div>
							<div className='control-item' onClick={toggle}>
								<IconList />
								<div className='text'>{isCHT ? '廠商名單' : 'Exhibitor List'}</div>
								<IconArrowDown />
							</div>

							<div className='collapsible' ref={setCollapsibleElement}>
								<div className={`control-item sub ${exhibitorSection === 'all' ? 'active' : ''}`} onClick={() => { showExhibitorList('all') }}>
									<div className='text'>{isCHT ? '全部' : 'All'}</div>
								</div>

								{exhibitorSections.map(section => (
									<div className={`control-item sub ${exhibitorSection === section ? 'active' : ''}`} key={section} onClick={() => { showExhibitorList(section) }}>
										<div className='text'>{section}</div>
									</div>
								))}
							</div>
						</div>
					)}
				</SlideToggle>

				<div className='control-item' onClick={showMyFavourites}>
					<IconHeart />
					<div className='text'>{isCHT ? '我的最愛' : 'Saved Exhibitors'}</div>
				</div>

				<div className='control-item' onClick={showSearch}>
					<IconSearch />
					<div className='text'>{isCHT ? '進階搜尋' : 'Advanced Search'}</div>
				</div>

				<SlideToggle collapsed>
					{({ toggle, setCollapsibleElement }) => (
						<div>
							<div className='control-item' onClick={toggle}>
								<IconPrint />
								<div className='text'>{isCHT ? '下載/列印' : 'Download/Print'}</div>
								<IconArrowDown />
							</div>

							<div className='collapsible' ref={setCollapsibleElement}>
								<a className='control-item sub' href={`${currentUrl}?page=single-floor&floor=${activeFloor}&lang=${isCHT ? 'CHT' : 'ENG'}`} target='_blank' rel='noreferrer noopener'>
									<div className='text'>{isCHT ? '單樓層' : 'Single Floor'}</div>
								</a>

								<a className='control-item sub' href={`${currentUrl}?page=multi-floor&lang=${isCHT ? 'CHT' : 'ENG'}`} target='_blank' rel='noreferrer noopener'>
									<div className='text'>{isCHT ? '全部地圖' : 'All Maps'}</div>
								</a>

								<a className='control-item sub' href={`${currentUrl}?page=exhibitor-list&lang=${isCHT ? 'CHT' : 'ENG'}`} target='_blank' rel='noreferrer noopener'>
									<div className='text'>{isCHT ? '展商名單' : 'Exhibitor List'}</div>
								</a>
							</div>
						</div>
					)}
				</SlideToggle>
			</div>
		</div>
	)
}

export default LeftPanel;